'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n'], ['\n    ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _fastDeepEqual = require('fast-deep-equal');

var _fastDeepEqual2 = _interopRequireDefault(_fastDeepEqual);

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PrimarySelection = (0, _styledComponents2.default)(_metrixCommon.PrimaryButton)(_templateObject, function (_ref) {
    var isMobile = _ref.isMobile;
    return !isMobile && ' height: 50px;';
});

var SecondarySelection = (0, _styledComponents2.default)(_metrixCommon.SecondaryButton)(_templateObject, function (_ref2) {
    var isMobile = _ref2.isMobile;
    return !isMobile && ' height: 50px;';
});

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        var _ref3;

        var _temp, _this, _ret;

        _classCallCheck(this, Component);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref3, [this].concat(args))), _this), _this.handleReturn = function (value) {
            _this.props.doSetReturn({ componentCode: _this.props.component.code, code: 'Value', value: value.code });
            _this.props.doSetReturn({ componentCode: _this.props.component.code, code: 'Label', value: value.value });

            var rules = (0, _metrixCommon.getElementsByCode)(_this.props.component.elements, 'Rules');
            if (rules) {
                rules.map(function (rule) {
                    _this.props.doSetReturn({ componentCode: _this.props.component.code, code: rule.code, value: rule.value });
                });
            }

            _this.props.trackAnalytics();
            _this.props.doStep('next');
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Component, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return !(0, _fastDeepEqual2.default)(this.props, nextProps);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var isMobile = this.context.screen.isMobile;
            var options = (0, _metrixCommon.getElementsByCode)(this.props.component.elements, 'Options');
            var emphasize = (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'Emphasize');

            var returnedSelection = this.props.return && this.props.return.elements && this.props.return.elements.filter(function (x) {
                return x.code === 'Value';
            })[0] || { "code": "", "value": "" };

            return _react2.default.createElement(
                _metrixCommon.Container,
                { fullSize: true, inline: !isMobile, top: isMobile ? _metrixCommon.Sizes.xs : _metrixCommon.Sizes.xs, bottom: isMobile ? _metrixCommon.Sizes.md : _metrixCommon.Sizes.md },
                options && options.map(function (option, i) {
                    var button = null;

                    var left = i > 0 && !isMobile ? _metrixCommon.Sizes.xs : _metrixCommon.Sizes.none;
                    var top = i > 0 && isMobile ? _metrixCommon.Sizes.xs : _metrixCommon.Sizes.none;
                    var disabled = i === 0 && !_this2.props.valid;

                    if (emphasize && option.code === emphasize) {
                        button = _react2.default.createElement(PrimarySelection, { key: 'Select' + i, disabled: disabled, text: option.value,
                            clickEvent: function clickEvent() {
                                return _this2.handleReturn(option);
                            }, isMobile: isMobile,
                            inverse: returnedSelection ? String(returnedSelection.value).toLowerCase() === String(option.code).toLowerCase() : false
                        });
                    } else if (option.code === 'skip') {
                        if (!_this2.props.valid) {
                            button = String(returnedSelection.value).toLowerCase() === String(option.code).toLowerCase() ? _react2.default.createElement(PrimarySelection, { key: 'Select' + i, text: option.value, left: left, top: top,
                                clickEvent: function clickEvent() {
                                    return _this2.handleReturn(option);
                                }, isMobile: isMobile
                            }) : _react2.default.createElement(SecondarySelection, { key: 'Select' + i, text: option.value, left: left, top: top,
                                clickEvent: function clickEvent() {
                                    return _this2.handleReturn(option);
                                }, isMobile: isMobile });
                        }
                    } else {
                        button = String(returnedSelection.value).toLowerCase() === String(option.code).toLowerCase() ? _react2.default.createElement(PrimarySelection, { key: 'Select' + i, disabled: disabled, text: option.value, left: left, top: top,
                            clickEvent: function clickEvent() {
                                return _this2.handleReturn(option);
                            }, isMobile: isMobile
                        }) : _react2.default.createElement(SecondarySelection, { key: 'Select' + i, disabled: disabled, text: option.value, left: left, top: top,
                            clickEvent: function clickEvent() {
                                return _this2.handleReturn(option);
                            }, isMobile: isMobile });
                    }

                    return button;
                })
            );
        }
    }]);

    return Component;
}(_react2.default.Component);

Component.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = Component;